function toutou_set_option(nom,valeur){
  // alert('Dans toutou_set_option, nom=' + nom + ',valeur='+valeur)
  cre_cook(nom,valeur,100);
  valeur=lit_cook(nom);
  // alert('Dans toutou_set_option apres lit_cook, nom=' + nom + ',valeur='+valeur)
}

function toutou_get_option(nom){
  var thermo   = new Toutou_Thermo();
  string=lit_cook(nom);
  // alert('Dans toutou_get_option, nom=' + nom + ',valeur='+string)

  if(nom == 'unite_vent'){
    if(string == ''){
      string='noeuds';
      toutou_set_option(nom,string);
    }
    if(string == "noeuds"){
      conv=1.;
    } else if (string == "km/h"){
      conv=thermo.knams*3600./1000.;
    }  else if (string == "m/s"){
      conv=thermo.knams;
    } else if (string == "mph"){
      conv=thermo.nkamph;
    }
    return {unite:string,conv:conv};
  }

  if(nom == 'sous_sol_hr'){
    if(string == ''){ 
      string='70';
      toutou_set_option(nom,string);
    }
    var my_real=string*1.;
    return {valeur:my_real};
  }

  if(nom == 'sous_sol_tt'){
    if(string == ''){ 
      string='18';
      toutou_set_option(nom,string);
    }
    var my_real=string*1.;
    return {valeur:my_real};
  }

  if(nom == 'sous_sol_est' || nom == 'sous_sol_sud' || nom == 'sous_sol_ouest'){
    if(string == ''){
      string='moyenne';
      toutou_set_option(nom,string);
    }
    return {valeur:string};
  }

  if(nom == 'debut_maintenant'){
    if(string == ''){ string='non'; }
    window.gstart_from_now = (string == 'oui');
    return {valeur:string};
  }

}
